// SeoHelmet.js
import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const SeoHelmet = ({ productsToDisplay = [] }) => {
  const { pathname } = useLocation();

  const getSeoData = (path) => {
    if (path.includes("/cart")) {
      return {
        title: "Stylori Silver | Cart",
        description: "Review your selected silver jewellery items before proceeding to checkout. Secure, easy, and stylish shopping with Stylori Silver.",
      };
    } else if (path.includes("/checkout")) {
      return {
        title: "Stylori Silver | Checkout",
        description: "Complete your purchase of elegant silver jewellery securely with Stylori. Fast checkout, safe payment options, and guaranteed quality.",
      };
    } else if (path.includes("/paymentsuccess")) {
      return {
        title: "Stylori Silver | Thanks",
        description: "Thank you for your order! Your silver jewellery purchase has been successfully placed. We’ll keep you updated on your delivery.",
      };
    } else if (path.includes("/paymentfail")) {
      return {
        title: "Stylori Silver | Order Failed",
        description: "Something went wrong while placing your order. Please try again or contact Stylori support for assistance with your silver jewellery purchase.",
      };
    } else if (path.includes("/account")) {
      return {
        title: "Stylori Silver | Account",
        description: "Access your Stylori account to view orders, manage addresses, and update your profile. Enjoy a personalized silver jewellery shopping experience.",
      };
    } else {
      return {
        title: "Online Jewellery Shopping in India | Gold and Diamond Jewellery Online",
        description: "Buy Gold and Diamond Jewellery Shopping Online from Stylori.com with variety of products like Pendants, Gold Rings, Bangles, Earrings",
      };
    }
  };

  const { title, description } = getSeoData(pathname);

  const imageUrl =
    productsToDisplay[0]?.productImagesByProductId[0]?.imageUrl ||
    "https://assets.stylori.com/assets/images/logo.jpg";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content="silver jewellery, Stylori, buy silver online" />
      <meta property="og:site_name" content="Stylori" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:width" content="200" />
      <meta property="og:image:height" content="200" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@StyloriLove" />
      <meta name="twitter:creator" content="@StyloriSilver" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="robots" content="index, follow" />
      <meta property="og:locale" content="en_US" />
    </Helmet>
  );
};

export default SeoHelmet;
